import React from 'react';

import HeadPicture from './HeadPicture'
import { Card } from '../../shared'

import css from './Home.module.scss'

const Home = () => {
  return (
    <div className={css.home}>
      <HeadPicture text="picture placeholder" />
      <div className={css.flex}>
        <div className={css.topLeft}>
          <Card title="Community Locker Self Storage">
            Whether it's for a long or short period of time, we are here to make your storage experience as easy as possible by offering a full range of products and services to meet your storage needs at an affordable price. Simply reserve a unit online or come by and see us today!
            <br/><br/>
            Located near the intersection of Route 56 and Wildlife Lodge Road; towards the Hillcrest Shopping Center
          </Card>
        </div>
        <div className={css.topRight}>
          <Card title="Store Hours">
            <div>Mon-Fri: 8:00 AM - 5:00 PM</div>
            <div>Sat: 8:00 AM - 5:00 PM</div>
            <div>Sun: 8:00 AM - 5:00 PM</div>
          </Card>
          <div className={css.spacer} />
          <Card title="Store Contact">
            <div>Address: 1175 Wildlife Lodge Road,</div>
            <div>Lower Burrell, PA 15068</div>
            <div>Phone: 724-923-3042</div>
            <div>Email: CommunityLockerSS@gmail.com</div>
          </Card>
        </div>
      </div>
      <Card title="Community Locker Features">
        <div className={css.bottomLine}>
          <div className={css.lineItem}>Self Storage and Parking</div>
          <div className={css.lineItem}>Cash, Check, and Credit Card</div>
          <div className={css.lineItem}>Convenient Access</div>
          <div className={css.lineItem}>Drive up storage</div>
        </div>
        <div className={css.bottomLine}>
          <div className={css.lineItem}>7 day / 24 hour access</div>
          <div className={css.lineItem}>Affordable Rates</div>
          <div className={css.lineItem}>Storage Floor Pallets Available</div>
          <div className={css.lineItem}>Discounts Available</div>
        </div>
        <div className={css.bottomLine}>
          <div className={css.lineItem}>Clean, Dry, Secure</div>
          <div className={css.lineItem}>Your lock and key - only accessable by you</div>
          <div className={css.lineItem} />
          <div className={css.lineItem} />
        </div>
      </Card>
    </div>
  )
}

export default Home;
